export default __webpack_public_path__ + "static/media/w_m_2026_h.45fce3bc.jpg";